<script>
import { onMount } from "svelte";
import {donationboxes} from "../../stores"

export let addDonationBoxBlock;
    let content = [];
    let db;
    
    onMount(() => {
        content = $donationboxes;
    }
    );
</script>
<div class="df-block-menu-list">
    <div class="title">Select a Donation Box</div>
    {#each content as c}
        <div class="df-block-menu-list-item" on:click={() => addDonationBoxBlock(c.id)}>{c.name}</div>
    {/each}
</div>

<style>
    .df-block-menu-list-item {
        padding: 7px 10px;
        background: #f9f9f9;
        border: 1px solid #ffffff;
        cursor: pointer;
    }
    .df-block-menu-list-item:hover {
        border: 1px solid #DDDDDD;
        background: #DDDDDD;
    }
    .title {
        padding: 7px 10px;
        margin-bottom: 10px;
        font-weight: bold;
    }
</style>